import { create, show, useModal } from "@ebay/nice-modal-react";

import FlashContext from "components/FlashMessages/FlashContext";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import useTypedContext from "hooks/useTypedContext";
import useDeleteRunLogs from "shared/Run/useDeleteRunLogs";

type RunDeleteLogsConfirmationProps = {
  stackId: string;
  runId: string;
  isModuleRun: boolean;
};

const RunDeleteLogsConfirmation = create(function RunDeleteLogsConfirmation({
  stackId,
  runId,
  isModuleRun,
}: RunDeleteLogsConfirmationProps) {
  const modal = useModal();
  const { reportSuccess } = useTypedContext(FlashContext);

  const [deleteRunLogs, { loading }] = useDeleteRunLogs({
    refetchQueries: [isModuleRun ? "GetModuleLogsNext" : "GetStackLogsNext"],
  });

  const onConfirm = () => {
    deleteRunLogs({ stack: stackId, run: runId }, (data) => {
      if (data?.runLogsDelete?.id) {
        reportSuccess({ message: "Run logs successfully deleted" });
        modal.resolve();
        modal.hide();
      }
    });
  };

  return (
    <DeleteConfirmationModal
      title="Delete run logs"
      confirmationButtonLabel="Delete logs"
      onConfirm={onConfirm}
      isLoading={loading}
      isDismissable={!loading}
    >
      <ConfirmationModalMessage>
        Deleting these logs is permanent and cannot be undone. All logs for this run, across every
        phase, will be removed.
      </ConfirmationModalMessage>
    </DeleteConfirmationModal>
  );
});

export const showDeleteRunLogsConfirmation = (props: RunDeleteLogsConfirmationProps) =>
  show(RunDeleteLogsConfirmation, props);
